import { Amount, reduceAndSumAmounts } from '@mews-distributor/common';

import { ApplicationState } from '../../../types';

interface WithAmounts {
    amounts: Amount[];
}

export const sumAmounts = (state: ApplicationState, { amounts }: WithAmounts) => reduceAndSumAmounts(amounts);
